import { render } from "./GridParcelas.vue?vue&type=template&id=2e8457e6&scoped=true"
import script from "./GridParcelas.vue?vue&type=script&lang=js"
export * from "./GridParcelas.vue?vue&type=script&lang=js"

import "./GridParcelas.vue?vue&type=style&index=0&id=2e8457e6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8457e6"]])

export default __exports__